export default {
  'business-case-for-abortion-access': {
    tag: 'abortion-access'
  }
};
